/**
 * IdType represents type of id/parentId. It should be number or string.
 * id: IdType;
 * parentId: IdType;
 * name: string; ...
*/
export class MultiListBoxItem<IdType = number> {
    public id: IdType;
    public name: string;
    public additionalInfo?: string;
    public isVisible? = true;
    public parentId: IdType;
    public isSelected?= true;
    public isCollapsed?= true;
    public children?: Array<MultiListBoxItem<IdType>>;
    public isAsync?: boolean;
    public visibleAll?: boolean;
    public hasCustomTemplate?: boolean;
    public isDisabled?: boolean;
    public hasSelectedChildren?= false;
    public selectedAllChildrenState?: MultiListBoxItemState;
}

export enum MultiListBoxItemState {
    None = 0,
    Indeterminate = 1,
    All = 2
}
